// extracted by css-extract-rspack-plugin
export default {"navLinkMobile":"navLinkMobile__CfHIW"};